import React, { useState, useEffect, useRef } from 'react';

import fileTypes from 'constants/file-types';

import { determineFileType } from 'utilities/file';

import FileDisplay from '../file-display';

import './index.scss';

const supportedImages = [
  'png',
  'jpeg',
  'svg',
  'webp',
  'gif'
];
const supportedVideos = [
  'mp4',
  'webm',
  'av1',
  'h264',
  'quicktime'
];

function UploadingFileDisplay(props) {

  const { fileType, rawFile, uploader, onComplete } = props;

  const [rootState, setRootState] = useState({
    uploaded: false,
    uploadedPercent: '0%',
    blobURL: null
  });

  const uploadStatusRef = useRef(false);

  useEffect(function onLoad() {

    uploadFile();

    tryConvertToParagraphNode();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function setBlobURL() {

    setRootState(function updateRootState(rootState) {

      return {
        ...rootState,
        blobURL: URL.createObjectURL(rawFile)
      };

    });

  }

  function tryConvertToParagraphNode() {

    if (isValidFile() === true) {
      setBlobURL();
      return;
    }

    props.switchToParagraphNode('');

  }

  function isValidFile() {

    if ((rawFile instanceof File) === false) {
      return false;
    }

    return true;

  }

  function handleUploadingError(rawFile, exception) {
    uploadStatusRef.current = false;
    if (exception.code !== 'ValidationError') {
      props.onError('Unknown error while uploading file. Check file size. Max allowed is 300mb', true);
      return;
    }

    const errors = exception.metadata;

    for (let error of errors) {

      if (error.instancePath === '/mimetype') {

        const message = `${rawFile.type} is not supported. Supported file types are ${supportedImages.join(', ')}, ${supportedVideos.join(', ')}!`;

        props.onError(message, true);

        break;

      }

    }

  }

  async function uploadFile() {

    if (uploadStatusRef.current === true) {
      return;
    }

    uploadStatusRef.current = true;

    const request = await uploader(rawFile);

    request.on('progress', progressHandler);

    request.on('success', successHandler);

    request.on('error', handleUploadingError.bind(null, rawFile));

  }

  function successHandler(files) {

    uploadStatusRef.current = false;

    setRootState(function updateRootState(_rootState) {
      return {
        ..._rootState,
        uploaded: true
      };
    });

    onComplete(files[0]);

  }

  function progressHandler(data) {

    let uploadedPercent = Math.floor(data.percent);

    if (uploadedPercent === 100) {
      uploadedPercent = 'finishing up...';
    } else {
      uploadedPercent = `${uploadedPercent}%`;
    }

    setRootState(function updateRootState(_rootState) {
      return {
        ..._rootState,
        uploadedPercent
      };
    });

  }

  function renderFileDisplay() {

    if (isValidFile() === false) {
      return;
    }

    if (rootState.blobURL === null) {
      return;
    }

    const fileType = determineFileType(rawFile);

    const fileDisplayProperties = {
      element: props.element,
      attributes: {
        ...props.attributes,
        file: {
          ...rawFile,
          url: rootState.blobURL,
          name: rawFile.name,
          mimetype: rawFile.type
        },
        fileType
      },
      uploading: true,
      uploadedPercent: rootState.uploadedPercent
    };

    return <FileDisplay {...fileDisplayProperties} />;

  }

  function renderMain() {

    return <div className='uploading-file-display-main'>

      <div className='raw-file-container'>
        {renderFileDisplay()}
      </div>

    </div>;

  }

  return renderMain();

}

export default UploadingFileDisplay;